// extracted by mini-css-extract-plugin
export default {"Main":"Badges_Main__8yNlw","Title":"Badges_Title__5q94Z","List":"Badges_List__wzyWA"};